import type { ProductLogoMediumProps } from "../types";

/**
 * 中サイズのCockpitロゴアイコン
 */
export function ProductLogoMediumCockpit({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        d="M21.1766 27.5295C21.1766 24.0208 24.0209 21.1765 27.5295 21.1765C31.0382 21.1765 33.8825 24.0208 33.8825 27.5295C33.8825 31.0381 31.0382 33.8824 27.5295 33.8824C24.0209 33.8824 21.1766 31.0381 21.1766 27.5295Z"
        fill="#57D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9027 24.9799C30.0864 24.7961 30.3844 24.7961 30.5682 24.9799L30.9009 25.3126C31.0847 25.4964 31.0847 25.7944 30.9009 25.9781L26.832 30.047C26.6482 30.2308 26.3503 30.2308 26.1665 30.047L24.2152 28.0958C24.0314 27.912 24.0314 27.614 24.2152 27.4303L24.548 27.0975C24.7318 26.9137 25.0297 26.9137 25.2135 27.0975L26.4993 28.3833L29.9027 24.9799Z"
        fill="#1A2142"
      />
      <path
        d="M28.9413 9.17651C29.3311 9.17651 29.6472 9.49255 29.6472 9.8824V11.2942C29.6472 11.684 29.3311 12 28.9413 12L14.8236 12C14.4338 12 14.1178 11.684 14.1178 11.2942L14.1178 9.8824C14.1178 9.49255 14.4338 9.17651 14.8236 9.17651L28.9413 9.17651Z"
        fill="white"
      />
      <path
        d="M28.9413 16.2353C29.3311 16.2353 29.6472 16.5514 29.6472 16.9412V18.353C29.6472 18.7428 29.3311 19.0589 28.9413 19.0589H14.8236C14.4338 19.0589 14.1178 18.7428 14.1178 18.353L14.1178 16.9412C14.1178 16.5514 14.4338 16.2353 14.8236 16.2353L28.9413 16.2353Z"
        fill="white"
      />
      <path
        d="M19.0589 23.2942C19.4488 23.2942 19.7648 23.6102 19.7648 24V25.4118C19.7648 25.8017 19.4488 26.1177 19.0589 26.1177H14.8236C14.4338 26.1177 14.1178 25.8017 14.1178 25.4118L14.1178 24C14.1178 23.6102 14.4338 23.2942 14.8236 23.2942H19.0589Z"
        fill="white"
      />
      <path
        d="M10.5884 9.17651C10.9782 9.17651 11.2942 9.49255 11.2942 9.8824V11.2942C11.2942 11.684 10.9782 12 10.5884 12H9.17659C8.78674 12 8.4707 11.684 8.4707 11.2942L8.4707 9.8824C8.4707 9.49255 8.78674 9.17651 9.17659 9.17651L10.5884 9.17651Z"
        fill="white"
      />
      <path
        d="M10.5884 16.2353C10.9782 16.2353 11.2942 16.5514 11.2942 16.9412V18.353C11.2942 18.7428 10.9782 19.0589 10.5884 19.0589H9.17659C8.78674 19.0589 8.4707 18.7428 8.4707 18.353L8.4707 16.9412C8.4707 16.5514 8.78674 16.2353 9.17659 16.2353H10.5884Z"
        fill="white"
      />
      <path
        d="M10.5884 23.2942C10.9782 23.2942 11.2942 23.6102 11.2942 24V25.4118C11.2942 25.8017 10.9782 26.1177 10.5884 26.1177H9.17659C8.78674 26.1177 8.4707 25.8017 8.4707 25.4118L8.4707 24C8.4707 23.6102 8.78674 23.2942 9.17659 23.2942H10.5884Z"
        fill="white"
      />
    </svg>
  );
}
